import * as React from 'react';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import { GraphqlQuery } from 'requestapijs';
import { Spin, AutoComplete } from 'antd';
import { OptionProps } from 'antd/lib/select';
import { CompanyService } from '../../service/CompanyService';
import { CompanyNodeEdge } from '../master/Company/constants';
import { ChallanNodeConnection } from '../../schema';

interface CustomOption extends OptionProps {
  label?: React.ReactNode;
}

const Option = AutoComplete.Option as React.ClassicComponentClass<CustomOption>;

interface ChallanDropDownProps extends AutoCompleteProps {
  extrafields: string[];
}

export class ChallanDropDown extends React.Component<
  ChallanDropDownProps,
  State
> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      challanNo: '',
      company: null,
    };
  }

  companyService = new CompanyService();

  componentDidMount() {
    this.companyService?.company$.subscribe((company) =>
      this.setState({ company }),
    );
  }

  render() {
    const { challanNo, company } = this.state;
    const { extrafields } = this.props;
    if (!company) return <Spin />;
    return (
      <GraphqlQuery
        queryString={`query ChallanDropDown($after: String!, $challanNo: String, $companyId: ID) {
          allChallans(companyId: $companyId, first: 10, challanNo_Icontains: $challanNo, after: $after) {
            edges {
              node {
                id
                challanNo
                productDetailsWithMargin {
                  productDetails
                }
                marginSet {
                  edges {
                    node {
                      id
                      freight
                      otherExpenses
                      productDetails
                    }
                  }
                }
              }
            }
          }
        }`}
        variables={{
          after: '',
          challanNo,
          companyId: company.id,
        }}
        render={(
          response: { allChallans: ChallanNodeConnection },
          error,
          loading,
        ) => {
          if (loading) {
            return <Spin />;
          }
          if (error) {
            return <div>{JSON.stringify(error)}</div>;
          }
          return (
            <div style={{ margin: '5px 0' }}>
              <AutoComplete
                {...this.props}
                placeholder="Select Challan"
                dataSource={response.allChallans.edges.map((value) => (
                  <Option key={value.node?.id} label={value.node}>
                    {value.node?.challanNo}
                  </Option>
                ))}
                optionLabelProp="children"
                style={{ width: '100%' }}
                onSearch={(value) => this.setState({ challanNo: value })}
              />
            </div>
          );
        }}
      />
    );
  }
}

interface State {
  company: CompanyNodeEdge | null;
  challanNo: string;
}
